"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";

export function SearchInputNoResults({}) {
  return (
    <Block className={"search-popover-heading-no-results"} tag={"div"}>
      <Block className={"no-results-text"} tag={"div"}>
        {"No Results Found"}
        <br />
        {"Please Change Your search"}
      </Block>
    </Block>
  );
}
